/** Atlas parallax video hero — Figma Hero Animation 1430px (3018:10316 / 3018:10318); accred strip Frame 12 4731:10534 / 4303:13430 / 3583:10535 */
export const BANNER_3_CONSTANTS = {
  METADATA_TITLES: {
    metadata:
      "Hero background images (if a hero video is set, it is shown by default; images are used only when no video is available). Add any number of slides.",
  },

  DEFAULT_ROW: {
    id: "1",
    image: "",
    alt_text: "",
    priority: 1,
    status: true,
  },

  METADATA_FIELDS: [
    {
      header: "Background image",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload background image",
      defaultValue: "",
      accept: "image/png,image/jpeg,image/webp,image/gif,image/svg+xml",
    },
    {
      header: "Alt text",
      fieldName: "alt_text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the image for accessibility",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Display order (lower shows first)",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable this slide",
      defaultValue: true,
    },
  ],

  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "hero_video_url",
      label:
        "Hero background video (if set, video is shown by default; background images from the table are used only when no video is available)",
      value: "",
      valueType: "file",
      filedType: "FILE",
      placeholder: "Upload Hero Background Video",
      defaultValue: "",
    },
    {
      fieldName: "title_1",
      label: "Eyebrow line (max 20 characters)",
      value: "Education That",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 20 characters",
      defaultValue: "Education That",
    },
    {
      fieldName: "title_1_color",
      label: "Eyebrow line color",
      value: "rgba(255,255,255,0.8)",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "rgba(255,255,255,0.8)",
    },
    {
      fieldName: "title_2",
      label: "Gradient headline (max 20 characters)",
      value: "Transforms",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 20 characters",
      defaultValue: "Transforms",
    },
    {
      fieldName: "title_2_gradient_start_color",
      label: "Title 2 Gradient Start Color",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#342B7C",
      defaultValue: "#342B7C",
    },
    {
      fieldName: "title_2_gradient_end_color",
      label: "Title 2 Gradient End Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#02A7B6",
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "title_2_gradient_angle",
      label: "Title 2 Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 90deg, 180deg",
      defaultValue: "90deg",
    },
    {
      fieldName: "subtitle",
      label: "Supporting copy (max 130 characters)",
      value:
        "We University brings premium, industry-aligned learning online. Build skills that matter, work on real challenges, and unlock your next big move.",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Max 130 characters",
      defaultValue:
        "We University brings premium, industry-aligned learning online. Build skills that matter, work on real challenges, and unlock your next big move.",
    },
    {
      fieldName: "subtitle_color",
      label: "Supporting copy color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "apply_now_text",
      label: "CTA label",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Button text",
      defaultValue: "Apply Now",
    },
    {
      fieldName: "apply_now_color",
      label: "CTA text color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#222222",
    },
    {
      fieldName: "button_color",
      label: "CTA button color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "explore_cta_url",
      label:
        "CTA link (leave empty to open lead form; or enter URL, path, or #section-id)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder:
        "e.g. https://example.com, /page, or #programs — empty = registration modal",
      defaultValue: "",
    },
    {
      fieldName: "background_color",
      label: "Fallback background",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#000000",
    },
    {
      fieldName: "accreditation_image_desktop",
      label: "Accrediation Image (Desktop)",
      value: "",
      valueType: "file",
      filedType: "FILE",
      placeholder: "Single strip image — parallax fade (sm+)",
      defaultValue: "",
      accept: "image/png,image/jpeg,image/webp,image/gif,image/svg+xml",
    },
    {
      fieldName: "accreditation_image_mobile",
      label: "Accrediation Image (Mobile)",
      value: "",
      valueType: "file",
      filedType: "FILE",
      placeholder: "Single strip image — below hero on small screens",
      defaultValue: "",
      accept: "image/png,image/jpeg,image/webp,image/gif,image/svg+xml",
    },
    {
      fieldName: "slide_frequency",
      label:
        "Background image rotation interval in milliseconds (used only when the hero video is not set and multiple images are added; e.g. 5000 = 5 seconds)",
      value: 5000,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "5000",
      required: false,
      defaultValue: 5000,
    },
    {
      fieldName: "status",
      label: "Banner Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
